<template>

  <!-- 路由出口 -->
  <!-- 路由匹配到的组件将渲染在这里 -->
  <router-view></router-view>
<!-- <HomeView></HomeView> -->
</template>
<script setup>
// import HomeView from "../src/views/HomeView.vue";
</script>
<style lang="scss">

</style>
